<template>
    <div id="page-home">
        <div class="page-title-box">
            <h2 class="page-title">Websites</h2>
        </div>
        <div class="website-container">
            <div class="card d-block" v-for="website in websites" :key="website.id">
                <div class="card-body">
                    <!-- project title-->
                    <h4 class="mt-0">
                        <router-link
                            :to="{name: 'website-settings', params: { site_id: website.id }}"
                            class="text-title"
                            v-text="website.name"
                        ></router-link>
                    </h4>
                    <span
                        class="product-state-label"
                        :class="[getStateClass(website)]"
                        v-text="getStateLabel(website)"
                    ></span>

                    <!-- project detail-->
                    <p class="mb-1 misc-info">
                        <span class="pr-2 text-nowrap d-inline-block">
                            <i class="dripicons-jewel text-muted"></i>
                            <b>{{ website.products_total }}</b> Products
                        </span>
                        <span class="text-nowrap d-inline-block" v-if="false">
                            <i class="dripicons-preview text-muted"></i>
                            <b>741</b> Views
                        </span>
                    </p>
                </div>
                <!-- end card-body-->
            </div>
            <div class="card d-block" v-if="false">
                <a href="#" @click.prevent="showCreateWebsiteModal()" class="btn-new">
                    <span class="i-circle">
                        <i class="dripicons-plus"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { EventBus } from "@/utils/EventBus.js";

export default {
    name: "Home",
    watch: {
        $route: {
            handler: "queryWebsites",
            immediate: true
        }
    },
    methods: {
        showCreateWebsiteModal() {
            EventBus.$emit("show-modal", "create-website-modal");
        },
        getStateLabel(website) {
            return website.state ? "Active" : "Inactive";
        },
        getStateClass(website) {
            return website.state ? "active" : null;
        },
        ...mapActions(["queryWebsites"])
    },
    computed: {
        ...mapState(["websites"])
    }
};
</script>

<style lang="scss" scoped>
.website-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(#{rem-calc(280)}, 1fr));
    gap: rem-calc(30);
    grid-auto-rows: minmax(rem-calc(200), 1fr);
    margin-bottom: rem-calc(30);

    & > .card {
        margin-bottom: 0;

        .misc-info {
            & > span {
                display: flex;
                align-items: center;

                & > i {
                    margin-right: rem-calc(5);
                }
            }
        }

        .product-state-label {
            display: inline-block;
            margin-bottom: rem-calc(5);
        }

        .btn-new {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            span.i-circle {
                display: flex;
                align-items: center;
                justify-content: center;
                width: rem-calc(100);
                height: rem-calc(100);
                border: rem-calc(2) solid $lighten-secondary-color;
                border-radius: 50%;
                transition: border-color 0.3s ease;

                & > .dripicons-plus {
                    font-size: rem-calc(60);
                    line-height: 0;
                    color: $lighten-secondary-color;
                    transition: color 0.3s ease;
                }
            }

            &:hover {
                span.i-circle {
                    border-color: $secondary-color;
                    & > .dripicons-plus {
                        color: $secondary-color;
                    }
                }
            }
        }
    }
}
</style>
